<template>
	<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
		<div class="form quick-form" v-if="booking_item != null && participant != null && package != null">
			<div class="row">
				<full-week :participant="participant" :bookingItem="booking_item" :package="package" v-if="package.price_per == 'week'"></full-week>
                <short-weeks :participant="participant" :bookingItem="booking_item" :package="package" v-else-if="$root.config.use_short_weeks"></short-weeks>
				<individual-days :participant="participant" :bookingItem="booking_item" :package="package" v-else></individual-days>
			</div>
		</div>
		<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else>
			<p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
		</div>
	</div>
</template>

<script>
    export default {
        data () {
            return {
                booking_item: null,
                participant: null,

                package: null,
                venue: null,
            }
        },
        computed: {
            booking_id: function () {
                return this.$route.params.bookingId;
            },
            locale: function () {
                return this.$root.locale.basket.quick_add_edit;
            }
        },
        components: {
            'booking-item': require('../Basket/BasketBookingItem.vue'),
            'full-week': require('./FullWeek.vue'),
            'individual-days': require('./IndividualDays.vue'),
            'short-weeks': require('./ShortWeeks.vue'),
        },
        created () {
            /** Getting the booking_item **/
            axios.get('/camp-booking/bookings/' + this.$route.params.bookingId + '/items/' + this.$route.params.bookingItemId)
                .then(response => {
                    this.booking_item = response.data.data;
                    this.booking_item.times_id = this.booking_item.start_time+'-'+this.booking_item.end_time;
                    this.$route.params.venueId = this.booking_item.venue_id;

                    /** Getting the participant **/
                    axios.get('/camp-booking/participants/'+this.booking_item.participant_id)
                        .then(response => {
                            this.participant = response.data.data;
                        })
						.catch(error => {
							this.$root.alert('This package no longer exists, redirecting to basket.');
							this.$router.push({ name: 'cart.basket' });
						});

                    /** Getting the booking package **/
                    axios.get('/camp-booking/packages/' +this.booking_item.package_id)
                        .then(response => {
                            this.package = response.data.data;
                        })
						.catch(error => {
							this.$root.alert('This package no longer exists, redirecting to basket.', 'danger', 2500);
							this.$router.push({ name: 'cart.basket' });
						});
                });

            /**
             * Setting the headers
             **/
            this.$root.headers = {

                navigate: {
                    name: 'cart.basket',
                    query: {
                        bookingId: this.booking_id
                    }
                },
                title: this.$root.locale.miscellaneous.page_headings.booking.edit_booking_item,
                show_venue: false,
                allow_change: false,
            }
        }
    }
</script>



// WEBPACK FOOTER //
// QuickEdit.vue?5317def6